import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";

// Entry point only: access is granted by existing server-side memberships.
// Opening a shared demo URL must not silently replace a client's active org.
export default function DemoEntry() {
  const { user, memberships, activeOrgId, setActiveOrgId } = useAuth();
  const navigate = useNavigate();
  const demos = (memberships || []).filter(({ org }) =>
    org?.is_demo === true && org.demo_mode === "immutable");

  if (user === undefined) return <p role="status">Chargement…</p>;

  return (
    <main className="min-h-screen bg-[#FAFAF6] px-6 py-16">
      <section className="mx-auto max-w-xl space-y-6 rounded-2xl border border-slate-200 bg-white p-8">
        <h1 className="font-heading text-2xl font-bold text-[#17201A]">Découvrir Lodge &amp; Co</h1>
        <p className="text-sm text-slate-600">Explorez un espace de démonstration en lecture seule. Les données illustratives et les résultats simulés sont identifiés dans le parcours.</p>
        {!user ? (
          <Link to="/login?next=demo" className="inline-block rounded-lg bg-[#1E3D2B] px-5 py-3 text-white">Se connecter pour accéder à la démonstration</Link>
        ) : (
          <>
            {demos.length === 0 && <p role="status">Aucun accès de démonstration actif n’est disponible pour votre compte. Contactez Lodge &amp; Co pour obtenir un accès.</p>}
            {demos.map(({ org }) => (
              <button key={org.id} type="button" className="block w-full rounded-lg bg-[#1E3D2B] px-5 py-3 text-white"
                onClick={() => { setActiveOrgId(org.id); navigate("/dashboard", { replace: true }); }}>
                Ouvrir la démonstration : {org.name}
              </button>
            ))}
            {activeOrgId && <Link to="/dashboard" className="block text-sm text-[#3E7256] underline">Continuer dans mon espace actuel</Link>}
          </>
        )}
      </section>
    </main>
  );
}
